module.exports = __webpack_public_path__ + "static/media/4_hotspot.fffcfbb6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/4_hotspot.mp4
// module id = 315
// module chunks = 0